/* eslint-disable */
export default {
  unknown: 'Tuntematon',
  anonymous: 'Nimetön',
  activeCalls: 'Kaikki puhelut',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
